import * as React from 'react';
import { IListRowRenderProps, ITest } from '../../../../data/types';
import { List } from '../../../shared/List/List';
import { LIST_ROW_HEIGHTS } from '../../../../constants/list_row_heights';

import { SelectedListItem } from './SelectedListItem';

interface IProps {
  tests: ITest[];
}

export const SelectedTestList = (props: IProps): React.ReactElement => {
  const listShape = [2, 1];
  /**
   * @description render function for list items
   * @param param0
   */
  const rowRenderer = ({
    index,
    key,
    style,
  }: IListRowRenderProps): React.ReactElement => {
    return (
      <SelectedListItem
        style={style}
        test={props.tests[index]}
        key={key}
        shape={listShape}
      />
    );
  };

  return (
    <List
      rowHeight={LIST_ROW_HEIGHTS.large}
      rowRenderer={rowRenderer}
      listLength={props.tests.length}
    />
  );
};
